<template>
    <div fields question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
        <questionheader :questionData="questionData" />
        <div data-question-main>
            <div data-kvk>
                <div>
                    <label :for="`search-company-${questionData.number}`">
                        {{$store.getters.textResource(`rs_search_company_kvk`)}}
                    </label>
                    <input 
                        type="search" 
                        :placeholder="$store.getters.textResource(`rs_search`)" 
                        :id="`search-company-${questionData.number}`" 
                        :list="`datalist-${questionData.number}`"
                        data-kvk-input
                        v-model="searchValue"
                        :data-has-value="searchValue.length > 2"
                        @blur="onSearchblur"
                        @keyup.enter.stop="onSearchblur"
                        autocomplete="off"
                        ref="companysearch"
                    />
                </div>
                <div v-if="userMessage !== ``">
                    <strong>{{userMessage}}</strong>
                </div>
                <div 
                    v-else-if="companies.length > 1"
                    aria-live="polite"
                >
                    <label :for="`select-company-${questionData.number}`">
                        {{$store.getters.textResource(`rs_select_company_kvk`)}}
                    </label>
                    <select 
                        :id="`select-company-${questionData.number}`"
                        @change="onCompanySelected"
                        ref="companyselect"
                    >
                        <option disabled="true" selected></option>
                        <option 
                            v-for="(company, index) in companies"
                            :key="index"
                            :value="index"
                        >
                            {{company}}
                        </option>
                    </select>
                </div>
            </div>
            <template v-if="Object.keys(selectedCompany).length > 0">
                <div
                    v-for="(answer, index) in questionData.answers"
                    data-answer
                    :key="`answer-${index}`"
                    :id="`question-${questionData.number}_answer-${index}`"
                >
                    <div data-answer-container :data-labels-next-to-answers="questionData.labelsNextToControl">
                        <questioninput
                            :answerData="answer"
                            :questionData="questionData"
                            :disabled="true"
                            :showPlaceholder="false"
                        />
                    </div>
                </div>
            </template>
        </div>
        <questionfooter :questionData="questionData" />
        <validationpopup :questionValidation="questionValidation" />
    </div>
</template>

<script>
import mixins from "@/global/mixins";
import methods from "@/global/methods";

export default {
    name: `fields-question`,
    mixins: [mixins.defaultQuestion],
    data(){
        return {
            companyOptions: [],
            selectedCompany: {},
            searchValue: ``,
            userMessage: ``
        }
    },
    watch: {
        selectedCompany(newValue){
            if(Object.keys(newValue).length === 0) return;

            methods.xhr({
                url: `/v1/custom/SearchCompanyProfile`,
                data: newValue.kvkNummer,
                isNoJson: true,
                callback: xhr => {
                    const response = JSON.parse(JSON.parse(xhr.responseText));
                    this.answers[0].openField = newValue.naam
                    this.answers[1].openField = response.totaalWerkzamePersonen
                    this.answers[2].openField = response._embedded.hoofdvestiging?.vestigingsnummer || newValue.vestigingsnummer
                    this.answers[3].openField = response._embedded.hoofdvestiging?.adressen[0].datumAanvang || response.materieleRegistratie.datumAanvang
                    this.answers[4].openField = response._embedded.hoofdvestiging?.adressen[0].postcode || response._embedded.hoofdvestiging?.adressen[0].postcodeWoonplaats
                    this.answers[5].openField = response._embedded.hoofdvestiging?.adressen[0].land
                    this.answers[6].openField = newValue.kvkNummer
                    this.answers[7].openField = response.sbiActiviteiten[0].sbiCode
                    
                    this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
                },
            });
        },
        companyOptions(){
            if(this.$refs.companyselect) {
                this.$refs.companyselect.selectedIndex = 0;
                this.$refs.companysearch.blur();
            }
        }
    },
    computed: {
        answers(){
            return this.questionData.answers
        },
        answersGiven() {
            return this.questionData.answers.filter(answer => answer.openField !== ``).length;
        },
        companies(){
            return this.companyOptions?.map(option => option.naam) || [];
        }
    },
    methods: {
        onCompanySelected(e){
            this.selectedCompany = this.companyOptions[parseInt(e.target.value)];
        },
        onSearchblur() {
            this.userMessage = ``;

            this.answers.forEach(a => a.openField = ``);

            if(this.searchValue.length > 2) {
                methods.xhr({
                    url: `/v1/custom/SearchCompany`,
                    data: this.searchValue,
                    callback: xhr => {
                        const response = JSON.parse(JSON.parse(xhr.responseText));

                        this.$store.commit(`changeGlobal`, {
                            variableName: `showLoader`,
                            newValue: false,
                        });
                        
                        if(response.fout) {
                            this.userMessage = response.fout[0].omschrijving

                            return;
                        }

                        this.companyOptions = response.resultaten;

                        if(this.companyOptions.length === 1) this.selectedCompany = this.companyOptions[0];
                    },
                });
            } else {
                this.selectedCompany = {};
                this.companyOptions = [];
            }
        }
    }
};
</script>

<style scoped>
[data-answer] {
    align-items: flex-start;
    flex-direction: column;
}

[data-answer-container] {
    display: flex;
    align-items: center;
    width: 100%;
}

[data-kvk] {
    min-height: 170px;
}

[data-kvk-input] {
    max-width: 300px;
}

body [data-kvk] {
    [id^=search-company] {
        border: 1px solid #454848;
        border-radius: 5px;
        font-size: 13px;
        padding: 8px 40px 8px 8px;
    }

    > div {
        display: flex;
        flex-direction: column;

        &:first-of-type {
            margin-bottom: 20px;
        }
    }

    label[for] {
        margin-bottom: 5px;
    }

    input[type=search] {
        background-color: white;
    }

    select {
        background: #fff;
        cursor: pointer;
        border: 1px solid;
        border-radius: 5px;
        width: 100%;
        max-width: 300px;
        color: #454848;
        display: block;
        padding: 8px 40px 8px 8px;
        text-overflow: ellipsis;
        -webkit-transition: none;
        transition: none;
        background-color: white;
    }
}

</style>